module.exports = __webpack_public_path__ + "img/FINANCEPR6.c08da233.png";